import { createAuthClient } from "better-auth/react";
import { env } from "./env";

/**
 * The auth API lives at `<api root>/api/auth`, where `<api root>` is the value
 * of VITE_API_BASE_URL (which itself ends in `/api` in dev and production).
 */
function resolveAuthBaseURL(): string {
  const base = env.VITE_API_BASE_URL.replace(/\/+$/, "");
  const root = base.endsWith("/api") ? base.slice(0, -4) : base;
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "http://localhost:5173";
  return `${root.startsWith("http") ? root : origin + root}/api/auth`;
}

export const authClient = createAuthClient({
  baseURL: resolveAuthBaseURL(),
  fetchOptions: {
    credentials: "include",
  },
});
